import React, { FC } from 'react';
import { useIsShopSideLaunched } from '../../hooks/useIsShopSideLaunched';
import AboutPage from '../AboutPage/AboutPage';
import LandingPageV2 from '../LandingPageV2/LandingPageV2';

const HomePage: FC = () => {
  const isShopSideLaunched = useIsShopSideLaunched();

  if (!isShopSideLaunched) {
    return <AboutPage />;
  }

  return <LandingPageV2 />;
};

export default HomePage;
